import React from 'react';
import { NextPage, GetStaticProps } from 'next';
import WidgetModel from '@/interfaces/widget';
import { db } from '@/config/firebase';
import widgetsFirestore from '@/services/firestore/widgets';
import Templates from '@/features/Templates';

export const getStaticProps: GetStaticProps = async () => {
  const { data: sharedWidgets, error } = await widgetsFirestore.queryStatic(
    db,
    {
      shared: ['==', true],
    }
  );
  if (error) throw error;

  const serializedSharedWidgets = sharedWidgets
    // Filter out widgets with 'chart' tag
    .filter((widget) => {
      return !widget.tags?.includes('chart');
    })
    .map((widget) => {
      delete widget.workbook;
      delete widget.project;
      delete widget.reportingWidget;
      delete widget.similarWidgets;
      widget.team = null;
      return widget;
    });

  return {
    props: {
      sharedWidgets: serializedSharedWidgets,
    },
  };
};

const TemplatesPage: NextPage<{ sharedWidgets: WidgetModel[] }> = ({
  sharedWidgets,
}) => {
  return <Templates widgets={sharedWidgets} />;
};

export default TemplatesPage;
